module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": _vm.titleCase(_vm.view) + ' Rates',
      "title-heading": "h2",
      "url": '/rates/' + _vm.view,
      "table-ref": _vm.view + 'ratesttable',
      "fields": _vm.fields,
      "hide-top": _vm.hideTop,
      "show-search": _vm.showSearch,
      "show-refresh": _vm.showRefresh,
      "search-placeholder": _vm.searchPlaceholder,
      "add-action": _vm.noAdd ? null : _vm.action,
      "add-props": _vm.noAdd ? null : _vm.addPropsData
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [(_vm.isManager('finance|management|admin')) ? _c('rates-action', {
          attrs: {
            "view": _vm.view,
            "show-range": !_vm.isUtil(),
            "row-data": props.rowData
          }
        }) : _vm._e()]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [(_vm.isManager('finance')) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "fa fa-trash",
            "circle": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRate(props.rowData)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a34a156"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/rates/RatesTable.vue
// module id = 1513
// module chunks = 0